
sap["ls"]["preload"]["UCF_Image"] = function() {/* global _assert, _trace, ERROR */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_ImageUtil */
/// <reference path="../core/ImageUtil.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_ImageDragDelegate */
/// <reference path="./delegates/ImageDragDelegate.js"/>
/* global UCF_ImageDropDelegate */
/// <reference path="./delegates/ImageDropDelegate.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Image(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Image["_"]["UCF_Image"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Image.js(36): UCF_Image"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef !== null, "oDomRef !== null", "Image.js(37): UCF_Image"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Image.js(38): UCF_Image"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["initializeHandle"](oDomRef);

	//same expression in renderer
	this["bAdjustImageSize"] = this["bAdjustImageSize"]
		&& this["sVisibility"] !== "NONE"
		&& (this["sWidth"] || this["sHeight"]);
	this["setClientProperty"]("AdjustImageSize", this["bAdjustImageSize"], true);
	this["bIsSVGTag"] = this["oDomRef"]["tagName"]["toUpperCase"]() === "SVG";
	//same expression in renderer
	this["bCanLayoutChange"] = this["bAdjustImageSize"]
		|| !this["sWidth"]
		|| !this["sHeight"]
		|| this["sWidth"]["indexOf"]("%") !== -1
		|| this["sHeight"]["indexOf"]("%") !== -1;

	this["bImageSizeAdjusted"] = false;
	this["bLayoutChangeProcessed"] = false;
	this["iInitialImgWidth"] = null;
	this["iInitialImgHeight"] = null;
	//next code is needed for the ITS image
	if (this["bItsMode"]) {
		this["bItsModeStretch"] = this["bItsMode"] && (this["sItsDisplayMode"] === "STRETCH" || this["sItsDisplayMode"] === "FIT" || this["sItsDisplayMode"] === "FITCENTER" || this["sItsDisplayMode"] === "FILL");
		this["bItsModeNormal"] = this["bItsMode"] && (this["sItsDisplayMode"] === "NORMAL" || this["sItsDisplayMode"] === "NORMALCENTER");
		this["oItsImgRef"] = null;
		if (this["bItsModeStretch"]) {
			this["oItsImgRef"] = UCF_DomUtil["$"](this["sId"] + "-r") || UCF_DomUtil["$"](this["sId"] + "-rITS");
			if (this["oItsImgRef"] && window["UCF_System"]["sDevice"] === "standards" && (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]() || UCF_UserAgent["bIsGecko"]())) {
				// Decouple-height-trick for IE11 when Image in ITS-mode is contained inside RasterLayoutItem which has the height defined and image has 100%
				// Otherwise IE will push the Image outside the scroll-container div
				this["oItsImgRef"]["style"]["position"] = "relative"; // div
				UCF_DomUtil["oGetFirstChild"](this["oItsImgRef"])["style"]["position"] = "absolute"; // table
			}
		}
		if (this["bItsModeNormal"]) {
			this["oItsImgRef"] = UCF_DomUtil["$"](this["sId"] + "-r") || UCF_DomUtil["$"](this["sId"] + "-rITS");
			this["oImgDomRef"] = UCF_DomUtil["$"](this["sId"]);
			if (this["oItsImgRef"] && this["oImgDomRef"] && window["UCF_System"]["sDevice"] !== "standards" && UCF_UserAgent["bIsIE"]()) {
				// For IE Quirks mode and Normal Display Mode, reset the table-layout
				UCF_DomUtil["oGetFirstChild"](this["oItsImgRef"])["style"]["tableLayout"] = "auto"; // table
			}
		}
		this["iITSWidth"] = 0;
		this["iITSHeight"] = 0;
		this["sFillVAlign"] = this["sVerticalTextAlign"]["toLowerCase"]();
		this["sFillHAlign"] = this["sHorizontalTextAlign"]["toLowerCase"]();
		this["oItsAlignRef"] = UCF_DomUtil["$"](this["sId"] + "-align");
	}
	this["bIgnoreLoad"] = this["bIsSVGTag"];
};window["UCF_Image"] = UCF_Image; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Image"); UCF_Image["_"] = {UCF_Image: 0}; }; ;
UCF_Image["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_Image.prototype["sClassName"] = "UCF_Image";

/**
 * Destructor
 */
UCF_Image["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["destroy"]++; }; 

	if (this["bCanLayoutChange"]) {
		UCF_JsUtil["clearDelayedCallsOfObject"](this);
		if (this["oDomRef"]) this["detachBrowserEvent"]("load", this["oDomRef"]);
		UCF_JsUtil["resetMassNotificationFilter"](UCF_Image);
	}

	if (this["oDomRef"]) this["detachBrowserEvent"]("error", this["oDomRef"]);
	this["bImageSizeAdjusted"] = false;
	this["bLayoutChangeProcessed"] = false;
	this["bCanLayoutChange"] = false;
	if (this["bItsModeStretch"] && this["oItsImgRef"] !== null) {
		this["detachBrowserEvent"]("resize", this["oItsImgRef"]);
	}
	if (this["oDragDelegate"]) {
		this["oDragDelegate"]["destroy"]();
		this["oDragDelegate"] = null;
	}
	if (this["oDropDelegate"]) {
		this["oDropDelegate"]["destroy"]();
		this["oDropDelegate"] = null;
	}
	this["bAdjustImageSize"] = null;
	this["bIsSVGTag"] = null;
	this["bIgnoreLoad"] = null;
	this["oItsImgRef"] = null;
	this["oItsAlignRef"] = null;
	this["oImgDomRef"] = null;
	this["sFillHAlign"] = null;
	this["sFillVAlign"] = null;
	this["iITSHeight"] = 0;
	this["iITSWidth"] = 0;
	this["iInitialImgHeight"] = 0;
	this["iInitialImgWidth"] = 0;
	this["bItsModeNormal"] = false;
	this["bItsModeStretch"] = false;

	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["destroy"] = 0; };

/**
 * Initialized the image, if automatic sizing is used
 */
UCF_Image["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["initialize"]++; }; 
	//See docu of method delayedInitialize
	UCF_JsUtil["delayedCall"](0, this, "delayedInitialize");
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["initialize"] = 0; };

/**
 * The delayed initialization
 * The initialization is made in a phase where the onload of the images are not processed though
 * the images are maybe already loaded.
 * If this is the case the "loaded" flag in the DOM element is not set and the image control needs to attach to the
 * "load" event. In the performance regression test we realized that this is performance relevant.
 * A delayed call to decouple the threads solved the problem. The DOM flag "loaded" is set if the
 * image is already loaded and the "load" event has not to be attached that often.
 *
 * This effect only occurs within applying the response of a delta request and not when a page is initially loaded
 */
UCF_Image["prototype"]["delayedInitialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["delayedInitialize"]++; }; 
	// SVG images do not set always the load flag
	if (this["oDomRef"]["bLoaded"] || this["oDomRef"]["complete"] || this["bIgnoreLoad"]) {
		// If Image already has been loaded before control has been instanciated
		// trigger onload "manually" without attaching load event handler
		this["processLoad"]();
	} else {
		if (window["UCF_System"]["sDevice"] !== 'standards' || !this["oDomRef"]["complete"])
			this["attachBrowserEvent"]("load", this["oDomRef"]);
	}

	if (this["oDomRef"]["bError"] || this["oDomRef"]["getAttribute"]("berror")) {
		this["processError"]();
	} else {
		this["attachBrowserEvent"]("error", this["oDomRef"]);
	}
	if (this["bItsModeStretch"] && this["oItsImgRef"] !== null) {
		this["attachBrowserEvent"]("resize", this["oItsImgRef"]);
		this["oItsImgRef"]["style"]["overflow"] = "hidden";
	}

	if (this["bItsModeNormal"] && this["oItsImgRef"]) {
		try {
			var sOverflowImgStr = UCF_DomUtil["sGetCurrentStyle"](this["oItsImgRef"], "overflow");
			if (sOverflowImgStr === "hidden" && !(UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]())) {
				// for Chrome the overflow is not working so I have to set the values
				// for e correct calculation
				this["oDomRef"]["style"]["display"] = "none";
				var iContainerHeight = this["oItsImgRef"]["clientHeight"];
				this["oDomRef"]["style"]["display"] = "";
				this["oItsImgRef"]["style"]["height"] = iContainerHeight + "px";
			}

		} catch (oException) {
			if (__UCF_TRACE__) { UCF_Tracer.trace(ERROR, oException + " ", "Image.js(190): delayedInitialize"); };
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["delayedInitialize"] = 0; };

UCF_Image["prototype"]["iGetInitialImgWidth"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["iGetInitialImgWidth"]++; }; 
	if (this["iInitialImgWidth"] === null) {
		this["iInitialImgWidth"] = this["oDomRef"]["offsetWidth"];
		if (!this["iInitialImgWidth"] && this["bIsSVGTag"]) {
			this["iInitialImgWidth"] = this["oDomRef"]["clientWidth"];
		}
	}

	return this["iInitialImgWidth"];
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["iGetInitialImgWidth"] = 0; };

UCF_Image["prototype"]["iGetInitialImgHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["iGetInitialImgHeight"]++; }; 
	if (this["iInitialImgHeight"] === null) {
		this["iInitialImgHeight"] = this["oDomRef"]["offsetHeight"];
		if (!this["iInitialImgHeight"] && this["bIsSVGTag"]) {
			this["iInitialImgHeight"] = this["oDomRef"]["clientHeight"];
		}
	}

	return this["iInitialImgHeight"];
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["iGetInitialImgHeight"] = 0; };

UCF_Image["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["onresize"]++; }; 

	this["adjustITSImageSize"]();

};;if (__UCF_COVERAGE__) { UCF_Image["_"]["onresize"] = 0; };

/**
 * Handles the onclick event of the browser
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_Image["prototype"]["onclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["onclick"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Image.js(231): onclick"); };

	this["activate"](oBrowserEvent);

	if (this["bIsInteractive"]) {
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["onclick"] = 0; };

UCF_Image["prototype"]["onmousedown"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["onmousedown"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Image.js(241): onmousedown"); };

	if (this["bIsInteractive"]) {
		oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["onmousedown"] = 0; };

UCF_Image["prototype"]["ondblclick"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["ondblclick"]++; }; 
	if (this["mEvents"]["DoubleClick"]) {
		this["fireDoubleClick"](this["sId"], oBrowserEvent["_iClientX"], oBrowserEvent["_iClientY"]);
		if (this["bIsInteractive"]) oBrowserEvent["cancelBubble"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["ondblclick"] = 0; };

UCF_Image["prototype"]["onlsselect"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["onlsselect"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Image.js(256): onlsselect"); };

	this["activate"](oBrowserEvent);
	if (this["bIsInteractive"]) oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["onlsselect"] = 0; };

/**
 * Returns the DOM element that should be focussed if the controls focus method
 * is called. Please do overide if the DOM element is other than the oRootRef
 * or the oDomRef.
 *
 * @return {HTMLElement} the DOM element that should be focussed if the
 * controls focus method is called.
 */
UCF_Image["prototype"]["oGetForcedFocusDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["oGetForcedFocusDomRef"]++; }; 
	return this["oDomRef"];
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["oGetForcedFocusDomRef"] = 0; };

UCF_Image["prototype"]["activate"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["activate"]++; }; 
	var oSourceRef = oBrowserEvent["oGetSource"]();

	if (oSourceRef["tagName"]["toLowerCase"]() === "area") {
		var sAreaId = oSourceRef["getAttribute"]("areaid");
		this["fireImageMapClick"](this["sId"], sAreaId);
	} else {
		if (!this["bIsInteractive"]) return;
		this["fireActivate"](this["sId"], oBrowserEvent["_iClientX"], oBrowserEvent["_iClientY"]);
	}
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["activate"] = 0; };

UCF_Image["prototype"]["onload"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["onload"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Image.js(287): onload"); };

	this["processLoad"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["onload"] = 0; };

UCF_Image["prototype"]["processLoad"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["processLoad"]++; }; 
	if (this["bCanLayoutChange"]) {
		this["adjustImageSize"]();
		this["processLayoutChange"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["processLoad"] = 0; };

UCF_Image["prototype"]["onerror"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["onerror"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Image.js(301): onerror"); };
	this["processError"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["onerror"] = 0; };

UCF_Image["prototype"]["processError"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["processError"]++; }; 

	if (this["bCanLayoutChange"] && this["sErrorImageSrc"]) {
		//try adjust with the error image
		this["adjustImageSize"]();
		this["processLayoutChange"]();
	} else {

		this["oDomRef"]["style"]["height"] = this["sHeight"];
		this["oDomRef"]["style"]["width"] = this["sWidth"];

		this["show"]();
	}
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["processError"] = 0; };

/**
 * In some cases the dimension of the image is not known before it is loaded. In this case the browser shows an
 * loading icon in a standard size while the screen is already calculated and visualized.
 * After the image is loaded the actual image dimensions are known, the image is correctly displayed and the
 * browser adapts the whole screen.
 * Some controls calculate their visualization depended on a UI state of a specific point in time. They need
 * to be notified when there are changes in the Layout so that they check their current visualization and
 * update it when necessary  (e.g. their position).
 *
 * This method is called to notify the framework about an potentional layout change
 * The method is centralized for all images loading. This means that only the last image loaded
 * should trigger the notification.
 *
 */
UCF_Image["prototype"]["processLayoutChange"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["processLayoutChange"]++; }; 

	if (this["bCanLayoutChange"] && !this["bLayoutChangeProcessed"]) {
		UCF_JsUtil["feedMassNotificationFilter"](1000, UCF_Image, this, "notifyLayoutChange");
	}
	this["bLayoutChangeProcessed"] = true;
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["processLayoutChange"] = 0; };

/**
 *  Adjust the ITS Image height/width
 *  	//Contract: %, em, ex width or height is not allowed to be used for adjust image mode
 */
UCF_Image["prototype"]["adjustITSImageSize"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["adjustITSImageSize"]++; }; 
	var dFactorHeight;
	var dFactorWidth;
	var iCurrentWidth;
	var iCurrentHeight;

	if (this["bItsModeStretch"] && this["oItsImgRef"] !== null) {
		var bApplyWidth = this["iITSHeight"] !== this["oItsImgRef"]["clientHeight"] ||
			this["iITSWidth"] !== this["oItsImgRef"]["clientWidth"];

		if (bApplyWidth) {
			this["iITSHeight"] = this["oItsImgRef"]["clientHeight"];
			this["iITSWidth"] = this["oItsImgRef"]["clientWidth"];
			if (this["sItsDisplayMode"] === "STRETCH") {
				var sStyleHeight = this["oDomRef"]["style"]["height"];
				if (sStyleHeight === "100%" && UCF_UserAgent["bIsWebKit"]()) {
					this["oDomRef"]["style"]["display"] = "none";
				}
				if (this["oItsImgRef"]["clientHeight"] !== this["oDomRef"]["clientHeight"] || sStyleHeight === "100%") {
					this["oDomRef"]["style"]["height"] = this["oItsImgRef"]["clientHeight"] + "px";
				}
				if (sStyleHeight === "100%" && UCF_UserAgent["bIsWebKit"]()) {
					this["oDomRef"]["style"]["display"] = "";
				}
			} else if (this["sItsDisplayMode"] === "FILL") {
				/*	o	Image aspect ratio is not changed
					o	Image is resized until the container is fully covered
					o	If image is larger than the container, the overlapping parts are simple cut off (no scrollbars)
					o	Algorithm:
					o	Calculate resize factor f = max( cx / ix, cy / iy )
					o	Multiply ix with f and iy
				 */
				/*	if ( !this.bIsSVGTag && !(UCF_UserAgent.bIsIE() || UCF_UserAgent.bIsMSEdge())) {
						// for Chrome the overflow is not working so I have to set the values
						// for e correct calculation
						this.oDomRef.style.display = "none";
						this.oItsImgRef.style.height = "100%";
					} */

				if (!this["bIsSVGTag"]) {
					dFactorHeight = this["oItsImgRef"]["clientHeight"] / this["iGetInitialImgHeight"]();
					dFactorWidth = this["oItsImgRef"]["clientWidth"] / this["iGetInitialImgWidth"]();
					var dFactorMax = Math["max"](dFactorHeight, dFactorWidth);
					var iContainerHeight = this["oItsImgRef"]["clientHeight"];
					iCurrentWidth = Math["round"](this["iGetInitialImgWidth"]() * dFactorMax);
					iCurrentHeight = Math["round"](this["iGetInitialImgHeight"]() * dFactorMax);
				} else {
					iCurrentWidth = Math["max"](this["oItsImgRef"]["clientWidth"], this["oItsImgRef"]["clientHeight"]);
					iCurrentHeight = iCurrentWidth;
				}

				//_trace(INFO, "== Image - " + this.sId + "; display: " + this.sItsDisplayMode + " - dFactorMax -  " + dFactorMax);

				this["oDomRef"]["style"]["height"] = iCurrentHeight + "px";
				this["oDomRef"]["style"]["width"] = iCurrentWidth + "px";
				if (!(UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]())) {
					// for Chrome the overflow is not working so I have to set the values
					// for e correct calculation
					this["oDomRef"]["style"]["display"] = "";
					this["oItsImgRef"]["style"]["height"] = iContainerHeight + "px";
				}
				//Set the Align for the image

				this["oDomRef"]["style"]["top"] = "0";
				this["oDomRef"]["style"]["left"] = "0";
				if (this["sFillVAlign"] !== "" && this["sFillVAlign"] !== "top") {
					if (iCurrentHeight > this["oItsImgRef"]["clientHeight"]) {
						var iTopPosition = 0;
						if (this["sFillVAlign"] === "middle") {
							iTopPosition = Math["round"]((iCurrentHeight - this["oItsImgRef"]["clientHeight"]) / 2);
						} else if (this["sFillVAlign"] === "bottom") {
							iTopPosition = Math["round"](iCurrentHeight - this["oItsImgRef"]["clientHeight"]);
						}
						//_trace(INFO, "== Image - " + this.sId + "- image - iTopPosition:" + iTopPosition );
						if (iTopPosition !== 0) {
							this["oDomRef"]["style"]["top"] = -iTopPosition + "px";
						}
					}
				}
				if (this["sFillHAlign"] !== "" && this["sFillHAlign"] !== "left") {
					if (iCurrentWidth > this["oItsImgRef"]["clientWidth"]) {
						var iLeftPosition = 0;
						if (this["sFillHAlign"] === "center") {
							iLeftPosition = Math["round"]((iCurrentWidth - this["oItsImgRef"]["clientWidth"]) / 2);
						} else if (this["sFillHAlign"] === "right") {
							iLeftPosition = Math["round"](iCurrentWidth - this["oItsImgRef"]["clientWidth"]);
						}
						//_trace(INFO, "== Image - " + this.sId + "- image - iLeftPosition:" + iLeftPosition );
						if (iLeftPosition !== 0) {
							this["oDomRef"]["style"]["left"] = -iLeftPosition + "px";
						}
					}
				}
			} else {
				/*
					o	Image aspect ratio is not changed
					o	Image is resized until the full image is visible with its maximum size
					o	Algorithm:
					o	Calculate resize factor f = min( cx / ix, cy / iy )
					o	Multiply ix with f and iy
				 */
				if (!this["bIsSVGTag"]) {
					dFactorHeight = this["oItsImgRef"]["clientHeight"] / this["iGetInitialImgHeight"]();
					dFactorWidth = this["oItsImgRef"]["clientWidth"] / this["iGetInitialImgWidth"]();
					var dFactorMin = Math["min"](dFactorHeight, dFactorWidth);

					this["oDomRef"]["style"]["height"] = Math["round"](this["iGetInitialImgHeight"]() * dFactorMin) + "px";
					this["oDomRef"]["style"]["width"] = Math["round"](this["iGetInitialImgWidth"]() * dFactorMin) + "px";
				} else {
					iCurrentWidth = Math["min"](this["oItsImgRef"]["offsetWidth"], this["oItsImgRef"]["offsetHeight"]);
					iCurrentHeight = iCurrentWidth;
					this["oDomRef"]["style"]["height"] = iCurrentHeight + "px";
					this["oDomRef"]["style"]["width"] = iCurrentWidth + "px";
				}
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["adjustITSImageSize"] = 0; };

UCF_Image["prototype"]["adjustImageSize"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["adjustImageSize"]++; }; 
	//Contract: %, em, ex width or height is not allowed to be used for adjust image mode

	this["adjustITSImageSize"]();

	if (!this["bAdjustImageSize"] || this["bImageSizeAdjusted"]) return;

	this["bImageSizeAdjusted"] = true;

	if (!this["bCanLayoutChange"] || this["bIsSVGTag"]) return;

	var iTargetWidth = parseInt(this["sWidth"]),
		iTargetHeight = parseInt(this["sHeight"]);

	if (isNaN(iTargetWidth) || iTargetWidth < 0) iTargetWidth = 0;
	if (isNaN(iTargetHeight) || iTargetHeight < 0) iTargetHeight = 0;

	//If one of these values is not defined, then the renderer
	//sets the other on the image and the browser calculates
	//the missing value proportionally

	if (iTargetWidth > 0 && iTargetHeight > 0) {
		var iPropHeight = iTargetHeight;

		if (this["oDomRef"]["offsetHeight"] && this["oDomRef"]["offsetWidth"]) { // if DOM element has a valid values
			iPropHeight = this["iGetProportionalSize"](iTargetWidth, this["oDomRef"]["offsetWidth"], this["oDomRef"]["offsetHeight"]);
		}

		//TargetWidth and TargetHeight have a defined value. In this scenario we assume
		//that the larger dimension is the one to be kept.
		//We leave calculation of the second proportional value to
		//the browser
		if (iPropHeight >= iTargetHeight) {
			this["oDomRef"]["style"]["height"] = iTargetHeight + "px";
		} else {
			this["oDomRef"]["style"]["width"] = iTargetWidth + "px";
		}
	}

	this["show"]();
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["adjustImageSize"] = 0; };

/**
 * Returns the proportional size dependend on the actual and maximal related size
 *
 * @param {int} iActSize
 * @param {int} iRelatedSize
 * @param {int} iRelatedMax
 * @return {integer}
 */
UCF_Image["prototype"]["iGetProportionalSize"] = function(iActSize, iRelatedSize, iRelatedMax) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["iGetProportionalSize"]++; }; 
	return Math["floor"](iActSize * (iRelatedMax / iRelatedSize));
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["iGetProportionalSize"] = 0; };

/**
 * Make the image visible
 */
UCF_Image["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["show"]++; }; 
	if (this["sVisibility"] === "VISIBLE") {
		this["oDomRef"]["style"]["visibility"] = "visible";
		UCF_DomUtil["removeClass"](this["oDomRef"], 'lsControl--hidden');
	}
	if (this["bItsMode"]) {
		this["oRootRef"]["style"]["height"] = "100%";
		this["oRootRef"]["style"]["width"] = "100%";
	} else {
		this["oRootRef"]["style"]["height"] = "auto";
		this["oRootRef"]["style"]["width"] = "auto";
	}
	this["oRootRef"]["style"]["display"] = "block";

};;if (__UCF_COVERAGE__) { UCF_Image["_"]["show"] = 0; };

/**
 * Writes the appropriate acc text into the tooltip
 * @param { UCF_BrowserEvent } oBrowserEvent the browser event object that occurred
 */
UCF_Image["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Image.js(544): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	oAccessibilityHelper["setControlType"]("IMG");

	oAccessibilityHelper["setEnabled"](this["bEnabled"]);

	if (!this["bIsDectorative"] && this["sSrc"] === '' && this["sTooltip"] === '' && !this["bIsNested"] && !this["bHasImageMap"]) {
		//image is in tabchain which have no tooltip and src should be read as 'image not available'
		oAccessibilityHelper["setTooltip"](oAccessibilityHelper["sGetText"]("EMPTY_IMG"));
	} else {
		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	}

	//Apply label and accDescription
	oAccessibilityHelper["applyLabelingInfo"](this, "", this["sLabelText"]);

	oAccessibilityHelper["addEnabledTutor"]("B_TUT", this["bEnabled"] && this["bIsInteractive"]);
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["onlsaccessibility"] = 0; };

/**
 * implements method from UCF_Control
 */
UCF_Image["prototype"]["createDragDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["createDragDelegate"]++; }; 

	if (!this["sDragSourceInfo"])
		return;

	if (this["oDragDelegate"])
		return;

	this["oDragDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_ImageDragDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDragDelegate"]);
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["createDragDelegate"] = 0; };

/**
 * implements method from UCF_Control
 */
UCF_Image["prototype"]["createDropDelegate"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["createDropDelegate"]++; }; 

	if (!this["sDropTargetInfo"])
		return;

	if (this["oDropDelegate"])
		return;

	this["oDropDelegate"] = new (UCF_ClassLoader["oGetClass"]("UCF_ImageDropDelegate"))(this["oLS"], this);
	this["addDelegate"](this["oDropDelegate"]);

};;if (__UCF_COVERAGE__) { UCF_Image["_"]["createDropDelegate"] = 0; };

/**
 * Activates native browser dragging by setting draggable attribute
 *
 * @private
 */
UCF_Image["prototype"]["setDraggable"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["setDraggable"]++; }; 
	if (this["sDragSourceInfo"]) {
		var oDragSourceInfo = this["oLS"]["oControlFactory"]["oGetControlById"](this["sDragSourceInfo"]);
		if (oDragSourceInfo) {
			if (oDragSourceInfo["bBrowserDragDrop"]) {
				this["bDraggable"] = true;
				this["oRootRef"]["setAttribute"]("draggable", true);
				this["oRootRef"]["setAttribute"]("iDDThreshold", 10000);
				this["oRootRef"]["ondragstart"] = null;
			} else {
				//explicitly set draggable to false to avoid native browser drag/drop if it isn't set in dragSourceInfo
				this["oRootRef"]["setAttribute"]("draggable", false);
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["setDraggable"] = 0; };

/**
 * Returns the image source
 *
 * @return {string}
 * @private
 */
UCF_Image["prototype"]["sGetImageSource"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["sGetImageSource"]++; }; 
	return UCF_ImageUtil["sGetImageSource"](this["oDomRef"]);
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["sGetImageSource"] = 0; };

/**
 * Prepare ARIA for Controls in SAPTable
 * @return {boolean}
 */
UCF_Image["prototype"]["bPrepareAria"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["bPrepareAria"]++; }; 
	/** @type {Node} */
	var oSapTableInfo;
	/** @type {Node} */
	var oParent;

	if (this["bNeedsAriaGeneric"] === undefined) {
		this["bNeedsAriaGeneric"] = false;

		oSapTableInfo = this["oInSapTable"]();

		if (oSapTableInfo) {
			this["bNeedsAriaGeneric"] = true;
			this["oDomRef"]["setAttribute"]('role', 'gridcell');
			UCF_Control["addAriaGeneric"](this["oDomRef"], oSapTableInfo);
			oParent = this["oDomRef"]["parentNode"];
			UCF_Control["addAriaGeneric"](oParent, oSapTableInfo);
			if (this["oDomRef"]["getAttribute"]("aria-labelledby"))
				oParent["setAttribute"]("aria-labelledby", this["oDomRef"]["getAttribute"]("aria-labelledby"));
			oParent["setAttribute"]('role', 'presentation');
		}
	}
	return this["bNeedsAriaGeneric"];
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["bPrepareAria"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Image["prototype"]["aAttributeNames"] = ["sTooltip","sWidth","sHeight","sSrc","bIsInteractive","bHasImageMap","sVisibility","bIsNested","sLabelText","bAdjustImageSize","sDragSourceInfo","bIsDragHandle","bEnabled","sErrorImageSrc","sCustomData","bItsMode","sItsDisplayMode","sCustomStyle","sDropTargetInfo","sVerticalTextAlign","sHorizontalTextAlign","bUsedInSapTable","sLabelledBy"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Image["prototype"]["aEventNames"] = ["Activate","ImageMapClick","Drag","Drop","DoubleClick"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Image["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_Image["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Image["prototype"]["sWidth"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Image["prototype"]["sHeight"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Image["prototype"]["sSrc"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Image["prototype"]["bIsInteractive"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Image["prototype"]["bHasImageMap"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Image["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {boolean}
 */
UCF_Image["prototype"]["bIsNested"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Image["prototype"]["sLabelText"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Image["prototype"]["bAdjustImageSize"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Image["prototype"]["sDragSourceInfo"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Image["prototype"]["bIsDragHandle"] = false;

/**
 * @private
 * @type {boolean}
 */
UCF_Image["prototype"]["bEnabled"] = true;

/**
 * @private
 * @type {string}
 */
UCF_Image["prototype"]["sErrorImageSrc"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Image["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Image["prototype"]["bItsMode"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.ImageItsDisplayMode}
 */
UCF_Image["prototype"]["sItsDisplayMode"] = "NORMAL";

/**
 * @private
 * @type {string}
 */
UCF_Image["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Image["prototype"]["sDropTargetInfo"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.VerticalTextAlign}
 */
UCF_Image["prototype"]["sVerticalTextAlign"] = "MIDDLE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.HorizontalTextAlign}
 */
UCF_Image["prototype"]["sHorizontalTextAlign"] = "CENTER";

/**
 * @private
 * @type {boolean}
 */
UCF_Image["prototype"]["bUsedInSapTable"] = false;

/**
 * @private
 * @type {string}
 */
UCF_Image["prototype"]["sLabelledBy"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Image["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Image["_"]["setDefaultValues"]++; }; 
	this["sTooltip"] = '';
	this["sWidth"] = '';
	this["sHeight"] = '';
	this["sSrc"] = '';
	this["bIsInteractive"] = false;
	this["bHasImageMap"] = false;
	this["sVisibility"] = "VISIBLE";
	this["bIsNested"] = false;
	this["sLabelText"] = '';
	this["bAdjustImageSize"] = false;
	this["sDragSourceInfo"] = '';
	this["bIsDragHandle"] = false;
	this["bEnabled"] = true;
	this["sErrorImageSrc"] = '';
	this["sCustomData"] = '';
	this["bItsMode"] = false;
	this["sItsDisplayMode"] = "NORMAL";
	this["sCustomStyle"] = '';
	this["sDropTargetInfo"] = '';
	this["sVerticalTextAlign"] = "MIDDLE";
	this["sHorizontalTextAlign"] = "CENTER";
	this["bUsedInSapTable"] = false;
	this["sLabelledBy"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Width", '', true);
		this["setClientProperty"]("Height", '', true);
		this["setClientProperty"]("Src", '', true);
		this["setClientProperty"]("IsInteractive", false, true);
		this["setClientProperty"]("HasImageMap", false, true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("IsNested", false, true);
		this["setClientProperty"]("LabelText", '', true);
		this["setClientProperty"]("AdjustImageSize", false, true);
		this["setClientProperty"]("DragSourceInfo", '', true);
		this["setClientProperty"]("IsDragHandle", false, true);
		this["setClientProperty"]("Enabled", true, true);
		this["setClientProperty"]("ErrorImageSrc", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("ItsMode", false, true);
		this["setClientProperty"]("ItsDisplayMode", "NORMAL", true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("DropTargetInfo", '', true);
		this["setClientProperty"]("VerticalTextAlign", "MIDDLE", true);
		this["setClientProperty"]("HorizontalTextAlign", "CENTER", true);
		this["setClientProperty"]("UsedInSapTable", false, true);
		this["setClientProperty"]("LabelledBy", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the Image
 * @param {number} iPositionX Horizontal offset of the click inside the image
 * @param {number} iPositionY Vertical offset of the click inside the image
 * @fires Image::Activate
 */
UCF_Image["prototype"]["fireActivate"] = function(sId, iPositionX, iPositionY) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["fireActivate"]++; }; 
	/** @type {{Id: string, PositionX: number, PositionY: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Image.js(884): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Image.js(885): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Image.js(886): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPositionX != null, "iPositionX != null", "Image.js(887): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPositionX) == "number", "typeof(iPositionX) == \"number\"", "Image.js(888): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPositionY != null, "iPositionY != null", "Image.js(889): fireActivate"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPositionY) == "number", "typeof(iPositionY) == \"number\"", "Image.js(890): fireActivate"); };
	mParams = {
		"Id": sId,
		"PositionX": iPositionX,
		"PositionY": iPositionY
	};
	
	
	
	this["fireSemanticEvent"]("Image", "Activate", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["fireActivate"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the Image
 * @param {string} sAreaId Identifier of the clicked area
 * @fires Image::ImageMapClick
 */
UCF_Image["prototype"]["fireImageMapClick"] = function(sId, sAreaId) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["fireImageMapClick"]++; }; 
	/** @type {{Id: string, AreaId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Image.js(912): fireImageMapClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Image.js(913): fireImageMapClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Image.js(914): fireImageMapClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sAreaId != null, "sAreaId != null", "Image.js(915): fireImageMapClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sAreaId) == "string", "typeof(sAreaId) == \"string\"", "Image.js(916): fireImageMapClick"); };
	mParams = {
		"Id": sId,
		"AreaId": sAreaId
	};
	
	
	this["fireSemanticEvent"]("Image", "ImageMapClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["fireImageMapClick"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control on which the drag has been initiated
 * @param {string} sDragSourceInfo Identifier of the drag source info control on which the drag has been initiated
 * @param {string} sDragSessionId Identifier of the dragSession to avoid mixing-up of the sessions
 * @fires Image::Drag
 */
UCF_Image["prototype"]["fireDrag"] = function(sId, sDragSourceInfo, sDragSessionId) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["fireDrag"]++; }; 
	/** @type {{Id: string, DragSourceInfo: string, DragSessionId: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Image.js(937): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Image.js(938): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Image.js(939): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceInfo != null, "sDragSourceInfo != null", "Image.js(940): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceInfo) == "string", "typeof(sDragSourceInfo) == \"string\"", "Image.js(941): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSessionId != null, "sDragSessionId != null", "Image.js(942): fireDrag"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSessionId) == "string", "typeof(sDragSessionId) == \"string\"", "Image.js(943): fireDrag"); };
	mParams = {
		"Id": sId,
		"DragSourceInfo": sDragSourceInfo,
		"DragSessionId": sDragSessionId
	};
	
	
	
	this["fireSemanticEvent"]("Image", "Drag", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["fireDrag"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of this control
 * @param {string} sDragSourceId Identifier of the control which was dragged
 * @param {string} sDropTargetInfo Identifier of the dropinfo control which is associated to this control
 * @param {string} sData arbitrary data which has been provided by the drag event from web dynpro
 * @param {string} sMimeType Mime type of the data provided by the drag event from web dynpro
 * @param {string} sDragSourceTags A space-seperated list of the tags of the drag source
 * @param {number} iMouseButton (1:left,2:right)
 * @param {number} iPosX The horizontal position
 * @param {number} iPosY The vertical position
 * @param {UCF_ClientInterfaces.E.DropEffect} sDropEffect The drop effect
 * @fires Image::Drop
 */
UCF_Image["prototype"]["fireDrop"] = function(sId, sDragSourceId, sDropTargetInfo, sData, sMimeType, sDragSourceTags, iMouseButton, iPosX, iPosY, sDropEffect) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["fireDrop"]++; }; 
	/** @type {{Id: string, DragSourceId: string, DropTargetInfo: string, Data: string, MimeType: string, DragSourceTags: string, MouseButton: number, PosX: number, PosY: number, DropEffect: UCF_ClientInterfaces.E.DropEffect}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 10, "arguments.length == 10", "Image.js(973): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Image.js(974): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Image.js(975): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceId != null, "sDragSourceId != null", "Image.js(976): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceId) == "string", "typeof(sDragSourceId) == \"string\"", "Image.js(977): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropTargetInfo != null, "sDropTargetInfo != null", "Image.js(978): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropTargetInfo) == "string", "typeof(sDropTargetInfo) == \"string\"", "Image.js(979): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "Image.js(980): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "Image.js(981): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sMimeType != null, "sMimeType != null", "Image.js(982): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sMimeType) == "string", "typeof(sMimeType) == \"string\"", "Image.js(983): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDragSourceTags != null, "sDragSourceTags != null", "Image.js(984): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDragSourceTags) == "string", "typeof(sDragSourceTags) == \"string\"", "Image.js(985): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iMouseButton != null, "iMouseButton != null", "Image.js(986): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iMouseButton) == "number", "typeof(iMouseButton) == \"number\"", "Image.js(987): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosX != null, "iPosX != null", "Image.js(988): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosX) == "number", "typeof(iPosX) == \"number\"", "Image.js(989): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPosY != null, "iPosY != null", "Image.js(990): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPosY) == "number", "typeof(iPosY) == \"number\"", "Image.js(991): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sDropEffect != null, "sDropEffect != null", "Image.js(992): fireDrop"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sDropEffect) == "string", "typeof(sDropEffect) == \"string\"", "Image.js(993): fireDrop"); };
	mParams = {
		"Id": sId,
		"DragSourceId": sDragSourceId,
		"DropTargetInfo": sDropTargetInfo,
		"Data": sData,
		"MimeType": sMimeType,
		"DragSourceTags": sDragSourceTags,
		"MouseButton": iMouseButton,
		"PosX": iPosX,
		"PosY": iPosY,
		"DropEffect": sDropEffect
	};
	
	
	
	
	
	
	
	
	
	
	this["fireSemanticEvent"]("Image", "Drop", mParams, false, true, false);
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["fireDrop"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the Image control.
 * @param {number} iPositionX Horizontal offset of the double click inside the image
 * @param {number} iPositionY Vertical offset of the double click inside the image
 * @fires Image::DoubleClick
 */
UCF_Image["prototype"]["fireDoubleClick"] = function(sId, iPositionX, iPositionY) {;if (__UCF_COVERAGE__) { UCF_Image["_"]["fireDoubleClick"]++; }; 
	/** @type {{Id: string, PositionX: number, PositionY: number}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 3, "arguments.length == 3", "Image.js(1030): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Image.js(1031): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Image.js(1032): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPositionX != null, "iPositionX != null", "Image.js(1033): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPositionX) == "number", "typeof(iPositionX) == \"number\"", "Image.js(1034): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(iPositionY != null, "iPositionY != null", "Image.js(1035): fireDoubleClick"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(iPositionY) == "number", "typeof(iPositionY) == \"number\"", "Image.js(1036): fireDoubleClick"); };
	mParams = {
		"Id": sId,
		"PositionX": iPositionX,
		"PositionY": iPositionY
	};
	
	
	
	this["fireSemanticEvent"]("Image", "DoubleClick", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Image["_"]["fireDoubleClick"] = 0; };

};